export default __webpack_public_path__ + "static/media/after@3x.4a7d5f1e.png";